import { useCallback, useState } from "react";
import { AlphaCard, Button, Icon, Popover, Stack, TextField, Tooltip } from "@shopify/polaris";
import { AlertMinor, ClockMinor } from "@shopify/polaris-icons";
import { chevron } from "../../../../../../../../assets/index.js";
import styles from "./TimeField.module.css";
import { UPDATES_FREQUENCY_EVERY_PERIOD } from "../../../../../../../../../constants/updatesFrequencyTypes.js";

// TODO add manual change time fields and refactor component

const formattedTime = (time) => {
  if (Number(time) < 10) {
    return `0${time}`;
  }

  return time;
};

const TimeField = ({ input }) => {
  const [visible, setVisible] = useState(false);

  const handleTimeDirection = useCallback((value) => {
    input.onChange({ ...input.value, selectedTime: { ...input.value.selectedTime, timeDirection: value } });
  }, [input]);

  const handleChangeMinutes = useCallback((value) => {
    if (Number(value) < 0 || Number(value) > 60) {
      return;
    }
    input.onChange({ ...input.value, selectedTime: { ...input.value.selectedTime, minutes: value } });
  }, [input]);

  const handleChangeHours = useCallback((value) => {
    if (Number(value) < 0 || Number(value) > 12) {
      return;
    }
    input.onChange({ ...input.value, selectedTime: { ...input.value.selectedTime, hours: value } });
  }, [input]);

  const formattedValue = ({ minutes, hours }) => `${formattedTime(hours)}:${formattedTime(minutes)}`;

  function handleOnClose() {
    setVisible(false);
  }

  return (
    <Popover
      active={visible}
      autofocusTarget="none"
      preferredAlignment="left"
      fullWidth
      preferInputActivator={false}
      preferredPosition="below"
      preventCloseOnChildOverlayClick
      onClose={handleOnClose}
      activator={
        <TextField
          role="combobox"
          label={
            <Stack alignment={"center"}>
              <span>Time</span>
              <Tooltip
                content="All dates and times within Stockhide are based on the UTC timezone."
                padding={"4"}
                preferredPosition={"above"}
              >
                <Icon
                  source={AlertMinor}
                  color="base"
                />
              </Tooltip>
            </Stack>
          }
          suffix={
            <Stack distribution={"center"} alignment={"center"}>
              <div>{input.value.selectedTime.timeDirection}</div>
              <Icon source={ClockMinor} />
            </Stack>
          }
          value={formattedValue(input.value.selectedTime)}
          onFocus={() => {
            if (!input.value.disableAction && input.value.type === UPDATES_FREQUENCY_EVERY_PERIOD) {
              return;
            }
            setVisible(true);
          }}
          autoComplete="off"
          readOnly
          disabled={!input.value.disableAction && input.value.type === UPDATES_FREQUENCY_EVERY_PERIOD}
        />
      }
    >
      <AlphaCard>
        <div style={{
          maxWidth: "270px",
          minHeight: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <Stack vertical alignment={"center"}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ width: "53px", marginRight: "6px", position: "relative" }}>
                <div
                  className={`${styles["chevron-wrapper"]} ${styles["chevron--up"]}`}
                  onClick={() => {
                    handleChangeHours(input.value.selectedTime.hours + 1);
                  }}
                >
                  <img src={chevron} alt={"chevron"} />
                </div>
                <TextField
                  label=""
                  labelHidden
                  autoComplete="off"
                  value={formattedTime(input.value.selectedTime.hours)}
                  align="center"
                  // onChange={handleChangeHours}
                />
                <div
                  className={`${styles["chevron-wrapper"]} ${styles["chevron--down"]} ${styles["rotate180"]}`}
                  onClick={() => {
                    handleChangeHours(input.value.selectedTime.hours - 1);
                  }}
                >
                  <img src={chevron} alt={"chevron"} />
                </div>
              </div>
              <div style={{ marginRight: "6px" }}>:</div>
              <div style={{ width: "53px", marginRight: "30px", position: "relative" }}>
                <div
                  className={`${styles["chevron-wrapper"]} ${styles["chevron--up"]}`}
                  onClick={() => {
                    handleChangeMinutes(input.value.selectedTime.minutes + 1);
                  }}
                >
                  <img src={chevron} alt={"chevron"} />
                </div>
                <TextField
                  label=""
                  labelHidden
                  autoComplete="off"
                  value={formattedTime(input.value.selectedTime.minutes)}
                  align="center"
                  // onChange={handleChangeMinutes}
                />
                <div
                  className={`${styles["chevron-wrapper"]} ${styles["chevron--down"]} ${styles["rotate180"]}`}
                  onClick={() => {
                    handleChangeMinutes(input.value.selectedTime.minutes - 1);
                  }}
                >
                  <img src={chevron} alt={"chevron"} />
                </div>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", height: "80px", justifyContent: "space-between" }}>
                <div
                  className={`${styles["time-direction-wrapper"]} ${input.value.selectedTime.timeDirection === "AM" ? `${styles["bg-blue"]} ${styles["color-white"]}` : styles["bg-grey"]}`}
                  onClick={() => {
                    handleTimeDirection("AM");
                  }}
                >
                  AM
                </div>
                <div
                  className={`${styles["time-direction-wrapper"]} ${input.value.selectedTime.timeDirection === "PM" ? `${styles["bg-blue"]} ${styles["color-white"]}` : styles["bg-grey"]}`}
                  onClick={() => {
                    handleTimeDirection("PM");
                  }}
                >
                  PM
                </div>
              </div>
            </div>
            <Button
              primary
              onClick={handleOnClose}
            >
              Select time
            </Button>
          </Stack>
        </div>
      </AlphaCard>
    </Popover>
  );
};

export default TimeField;